var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"brown lighten-5",staticStyle:{"overflow-y":"scroll"},attrs:{"id":"left-drawer","clipped":"","app":"","width":"250"}},[_c('drawer-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }